import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Project Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Challenges:</h3>
              <p>Key issues included system integration, reliability, and compliance—each resolved with practical, security-focused solutions.</p>

              {/* List of Project Challenges */}
              <ul>
                {portfolio.challenges.map((challenge, index) => {
                  return <li key={index}><div className='icon'><FaCheck /></div>{challenge}</li>
                })}
              </ul>

            </div>

            {/* Project Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Solutions:</h3>
              <p>We implemented secure, customized solutions—ranging from smart locks to integrated alarm systems—aligned with client needs.</p>

              {/* Project Solutions List */}
              <ul>
                {portfolio.solutions.map((solution, index) => {
                  return <li key={index}><div className='icon'><FaCaretRight /></div>{solution}</li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Results:</h3>
              <p>The project delivered enhanced security, timely completion, and high client satisfaction with reliable, data-backed outcomes.</p>

              {/* Project Results */}
              <ul>
                {portfolio.results.map((result, index) => {
                  return <li key={index}><div className='icon'><FaCircleNotch /></div>{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;